import React from "react";
import {Globe, ImagePlay, ImageUp, MonitorSmartphone, Printer, Puzzle, TabletSmartphone, Zap} from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {
    Section8UseCaseScaffold,
    ISection8UseCase,
} from "components/features/CompressorCommon/Section8UseCaseScaffold";

const bestUseList: ISection8UseCase[] = [
    {
        title: "compact-crisp-creative-gifs-title",
        subTitle: "compact-crisp-creative-gifs-sub-title",
        icon: <ImageUp strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "ready-for-any-platform-title",
        subTitle: "ready-for-any-platform-sub-title",
        icon: <MonitorSmartphone strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "smooth-playback-every-time-title",
        subTitle: "smooth-playback-every-time-sub-title",
        icon: <ImagePlay strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "share-faster-anywhere-title",
        subTitle: "share-faster-anywhere-sub-title",
        icon: <Zap strokeWidth={1.5} width={30} height={30} />,
    },
];
const BestUsageForGifCompressorSection = () => {
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName="best-usage-online-tool-title" />}
            useCases={bestUseList}
        />
    );
};

export default BestUsageForGifCompressorSection;

